// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Raleway', 'Raleway Fallback'","fontStyle":"normal"}};